import { useUIStore } from '@/store/ui';
import styles from './Toast.module.css';

export function ToastViewport(): JSX.Element {
  const toasts = useUIStore((s) => s.toasts);
  const dismiss = useUIStore((s) => s.dismissToast);

  return (
    <div className={styles.viewport} aria-live="polite">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`${styles.toast} ${styles[`v_${t.variant ?? 'info'}`]}`}
          onClick={() => dismiss(t.id)}
        >
          {t.title && <div className={styles.title}>{t.title}</div>}
          <div className={styles.body}>{t.body}</div>
        </div>
      ))}
    </div>
  );
}
